<template>
	<div class="pb-5">
		<v-layout wrap v-if="filterBySubsidiary">
			<v-flex xs12 px-5 pt-3>
				<span class="caption">Empresa</span>
				<v-autocomplete
					solo
					:height="33"
					hide-details
					item-text="name"
					item-value="id"
					:items="subsidiaries"
					label="Empresa"
					return-object
					:search-input.sync="search"
					:value="subsidiaryId"
					@input="$emit('set-id', $event, 'subsidiaryId')"
				></v-autocomplete>
			</v-flex>
		</v-layout>
		<searcher-list
			:columns="columns"
			:current-page="currentPage"
			:rows="rows"
			:account-name="accountName"
			:last-page="lastPage"
			text-btn="Seleccionar"
			@on-page="$emit('on-page', $event)"
			@on-search="$emit('on-search', $event)"
			@add-record="$emit('add-record', $event)"
		/>
		<section class="modal-filter-footer">
			<modal-sidebar-button
				hidden
				success-color="primary"
				success-text="Cerrar"
				@accept-button-clicked="$emit('on-close')"
			></modal-sidebar-button>
		</section>
	</div>
</template>

<script>
	import searcherList from '@/components/shared/searcher/searcher-list';

	function mounted() {
		if (this.subsidiaryId) {
			this.params.subsidiaryId = this.subsidiaryId;
			this.$emit('search-subsidiary', this.subsidiaryId, true);
		}
	}

	function search(value) {
		if (value) {
			const validName = this.subsidiaryName ?
				value.trim().toLowerCase() !== this.subsidiaryName.trim().toLowerCase() :
				!this.subsidiaryName;
			if (validName) {
				this.$emit('search-subsidiary', value);
			}
		}
	}

	function data() {
		return {
			search: null,
			subsidiaryName: null,
		};
	}

	export default {
		name: 'slide-searcher',
		components: {
			searcherList,
		},
		data,
		mounted,
		props: {
			columns: {
				default: () => [],
				type: Array,
			},
			currentPage: {
				default: 1,
				type: Number,
			},
			filterBySubsidiary: {
				default: false,
				type: Boolean,
			},
			lastPage: {
				default: 0,
				type: Number,
			},
			rows: {
				default: () => [],
				type: Array,
			},
			subsidiaries: {
				default: () => [],
				type: Array,
			},
			subsidiaryId: [Number, String],
			textBtn: {
				default: 'Agregar',
				type: String,
			},
			accountName: {
				default: null,
				type: String,
			},
		},
		watch: {
			search,
			$route(newVal) {
				if (newVal) {
					if (newVal.name === 'ledger') {
						if (this.subsidiaryId) {
							this.params.subsidiaryId = this.subsidiaryId;
							this.$emit('search-subsidiary', this.subsidiaryId, true);
						}
					}
				}
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/shared/searcher/slide-searcher.vue